import {atom} from 'recoil';

import {Features} from '@lexian/api/support-api';

export const featureFlagState = atom<Features>({
  key: 'featureFlagState',
  default: undefined,
});
